export class AuthenticationException extends Error {
  public errorCode: string;
  constructor(message: string, errorCode: string) {
    super(message);
    this.errorCode = errorCode;
    this.name = 'AuthenticationException';
  }
}
